/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateEmploymentPasscode} from '../api'

export const useMutationUpdateEmploymentPasscode = createReactQueryMutationHook('updateEmploymentPasscode', updateEmploymentPasscode)
